import React, { useState, useEffect, useRef } from "react";
import { Send } from "lucide-react";

export default function TraderCommunityChat() {
  const [messages, setMessages] = useState([
    {
      id: 1,
      sender: "Ava (Gold Analyst)",
      avatar: "/assets/avatar/avatar1.jpg",
      text: "Hey everyone 👋 Tomorrow’s XAU/USD looks bullish unless 2032 breaks. Watch 2044 zone carefully!",
      side: "left",
      time: "21:04",
    },
    {
      id: 2,
      sender: "Raj Trader",
      avatar: "/assets/avatar/avatar6.jpg",
      text: "Yes Ava, liquidity might sweep under 2030 before moving up.",
      side: "right",
      time: "21:06",
    },
    {
      id: 3,
      sender: "Liam FX",
      avatar: "/assets/avatar/avatar8.jpg",
      text: "I’m seeing divergence on RSI 1H — small retracement likely before push.",
      side: "left",
      time: "21:07",
    },
    {
      id: 4,
      sender: "You",
      avatar: "/assets/avatar/avatar13.jpg",
      text: "Entry around 2030-2032 looks great. Targeting 2048-2050 if momentum continues.",
      side: "right",
      time: "21:09",
    },
    {
      id: 5,
      sender: "Ava (Gold Analyst)",
      avatar: "/assets/avatar/avatar15.jpg",
      text: "Exactly ✅ Use tight SL below 2025 — volume spike confirms support.",
      side: "left",
      time: "21:10",
    },
    {
      id: 6,
      sender: "JamesFX",
      avatar: "/assets/avatar/avatar5.jpg",
      text: "Guys, any idea about upcoming data releases tomorrow?",
      side: "left",
      time: "21:11",
    },
    {
      id: 7,
      sender: "Regina Trader",
      avatar: "/assets/avatar/avatar2.jpg",
      text: "Non-Farm Payroll preview — expect volatility ⚠️",
      side: "right",
      time: "21:12",
    },
    {
      id: 8,
      sender: "Ava (Gold Analyst)",
      avatar: "/assets/avatar/avatar9.jpg",
      text: "Let’s review live charts pre-London session 📊 I’ll post updated levels in the group.",
      side: "left",
      time: "21:14",
    },
  ]);

  const [newMessage, setNewMessage] = useState("");
  const chatEndRef = useRef(null);

  // Auto-scroll
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const sendMessage = () => {
    if (!newMessage.trim()) return;
    const msg = {
      id: messages.length + 1,
      sender: "You",
      avatar: "/assets/avatar/avatar4.png",
      text: newMessage.trim(),
      side: "right",
      time: new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }),
    };
    setMessages([...messages, msg]);
    setNewMessage("");
  };

  return (
    <div className="flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-[#0B0F19] shadow-[0_0_25px_rgba(0,0,0,0.3)]">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-white/10 bg-[#121826] px-4 py-3">
        <h2 className="text-sm font-semibold text-white">
          💬 Gold Market Group — Live Chat
        </h2>
        <span className="text-xs text-gray-400">
          {messages.length} messages
        </span>
      </div>

      {/* Chat Body */}
      <div className="flex-1 space-y-4 overflow-y-auto bg-slate-950/40 p-4">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex items-end ${
              msg.side === "right" ? "justify-end" : "justify-start"
            }`}
          >
            {msg.side === "left" && (
              <img
                src={msg.avatar}
                alt={msg.sender}
                className="mr-2 h-8 w-8 rounded-full border border-slate-700"
              />
            )}
            <div
              className={`max-w-[75%] rounded-2xl px-4 py-2 text-sm leading-relaxed shadow ${
                msg.side === "right"
                  ? "rounded-tr-none bg-blue-600/80 text-white"
                  : "rounded-tl-none bg-slate-800/80 text-gray-100"
              }`}
            >
              <p className="mb-1 text-xs font-semibold opacity-80">
                {msg.sender}
              </p>
              <p>{msg.text}</p>
              <p className="mt-1 text-right text-[10px] text-gray-300">
                {msg.time}
              </p>
            </div>
            {msg.side === "right" && (
              <img
                src={msg.avatar}
                alt={msg.sender}
                className="ml-2 h-8 w-8 rounded-full border border-slate-700"
              />
            )}
          </div>
        ))}
        <div ref={chatEndRef} />
      </div>

      {/* Input Field */}
      <div className="flex items-center gap-2 border-t border-white/10 bg-[#121826] p-3">
        <input
          type="text"
          placeholder="Type your message..."
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          className="flex-1 rounded-lg border border-slate-700 bg-slate-900/70 px-3 py-2 text-sm text-white outline-none focus:ring-1 focus:ring-blue-500"
        />
        <button
          onClick={sendMessage}
          className="rounded-full bg-blue-600 p-2 text-white hover:bg-blue-700"
        >
          <Send size={16} />
        </button>
      </div>
    </div>
  );
}
